import type { FC } from "react";
import React from "react";
import { Trans, useTranslation } from "@edreamsodigeo/frontend-core";
import { Flex, Heading } from "@edreamsodigeo/prisma-design-system";

import { useFilterOfferByType } from "~/clientState/hooks/useFilterOfferByType";
import useGetSubscriptionOffers from "~/clientState/hooks/useGetSubscriptionOffers";
import {
  SubscriptionOfferPeriod,
  SubscriptionOfferType,
  type SubscriptionResponse,
} from "~/generated/graphql";
import {
  freeTrialDays,
  RenewalPrice,
  renewalTimeKey,
} from "~/tools/subscriptionUtils";

const WaitingPageLabelMeta: FC = () => {
  const { t } = useTranslation();
  const { offers: offersList } = useGetSubscriptionOffers({
    offerPeriod: SubscriptionOfferPeriod.FreeTrial,
  });
  const basicOffer: SubscriptionResponse | undefined = useFilterOfferByType({
    offersList,
    subscriptionOfferType: SubscriptionOfferType.Basic,
  });
  const plusOffer: SubscriptionResponse | undefined = useFilterOfferByType({
    offersList,
    subscriptionOfferType: SubscriptionOfferType.Plus,
  });

  return (
    <Flex flexDirection={"column"}>
      <Heading
        type={"4"}
        textAlign={"center"}
        color={"neutral.90"}
        sx={{ lineHeight: "1.4" }}
      >
        <Trans
          i18nKey={"waitings.paxStep.description"}
          values={{
            freeTrialDays: freeTrialDays(basicOffer?.duration),
            freeTrialPeriod: t("prime.renewalDuration.days"),
            renewalPlusPrice: plusOffer?.renewalPrice.amount,
            renewalTime: t(renewalTimeKey(basicOffer?.renewalDuration)),
            renewalPlusTime: t(renewalTimeKey(plusOffer?.renewalDuration)),
          }}
          components={{
            renewalPrice: (
              <RenewalPrice
                currency={basicOffer?.renewalPrice.currency}
                amount={basicOffer?.renewalPrice.amount}
              />
            ),
            renewalPlusPrice: (
              <RenewalPrice
                currency={plusOffer?.renewalPrice.currency}
                amount={plusOffer?.renewalPrice.amount}
              />
            ),
          }}
        />
      </Heading>
    </Flex>
  );
};
export default WaitingPageLabelMeta;
